module.exports = require("@swa-ui/itinerary/src/ItineraryDateRange/ItineraryDateRange.module.scss");